<script>
import earthImage from "../../assets/newImges/sellers-page/earth.png";
import delivery from "../../assets/newImges/sellers-page/delivery.png";
import money from "../../assets/newImges/sellers-page/money-sack.png";
import eventBus from "@/shared/eventBus.js";
import { mapState } from "vuex";
export default {
  name: "SellersHome",
  data() {
    return {
      earth: earthImage,
      delivery: delivery,
      money: money
    };
  },
  methods: {
    openSignInModal() {
      if (this.userIsLoged) {
        this.$router.push({
          name: "Profile",
          params: { lang: this.$i18n.locale }
        });
        return;
      }
      let params = {
        modalData: { userIsLoged: this.userIsLoged },
        component: "signInMod"
      };
      eventBus.$emit("openModal", params);
    },
    openRegisterModal() {
      if (this.userIsLoged) {
        this.$router.push({
          name: "Profile",
          params: { lang: this.$i18n.locale }
        });
        return;
      }
      eventBus.$emit("openModal", { component: "chooseRegistrationModal" });
    }
  },
  computed: {
    ...mapState(["userIsLoged"])
  }
};
</script>
<template>
  <div id="sellers-home">
    <header>
      <h1>{{ $t("sellers.header.title") }}</h1>
      <p>{{ $t("sellers.header.subtitle1") }}</p>
      <p>{{ $t("sellers.header.subtitle2") }}</p>
      <p>{{ $t("sellers.header.subtitle3") }}</p>
      <div @click="openRegisterModal" class="btn dark">
        {{ userIsLoged ? $t("nav.profile") : $t("sellers.register.button") }}
      </div>
    </header>
    <main>
      <div>
        <h2>{{ $t("sellers.main.title") }}</h2>
        <p>{{ $t("sellers.main.subtitle") }}</p>
      </div>
      <div class="items">
        <div class="item">
          <div>
            <img :src="money" alt="money" />
          </div>
          <p>{{ $t("sellers.main.items.1") }}</p>
        </div>
        <div class="item bigger">
          <div>
            <img :src="delivery" alt="delivery" />
          </div>
          <p>{{ $t("sellers.main.items.2") }}</p>
        </div>
        <div class="item">
          <div>
            <img :src="earth" alt="globe" />
          </div>
          <p>{{ $t("sellers.main.items.3") }}</p>
        </div>
      </div>
    </main>
    <section>
      <div>
        <h2>{{ $t("sellers.register.title") }}</h2>
        <p>{{ $t("sellers.register.subtitle1") }}</p>
        <p>{{ $t("sellers.register.subtitle2") }}</p>

        <a @click="openRegisterModal" class="btn dark">
          {{ userIsLoged ? $t("nav.profile") : $t("sellers.register.button") }}
        </a>
        <p v-if="!userIsLoged">
          {{ $t("sellers.register.alreadyMember") }}
          <span @click="openSignInModal" class="underlined">{{
            $t("sellers.register.login")
          }}</span>
        </p>
      </div>
    </section>
  </div>
</template>
<style lang="scss" scoped>
#sellers-home {
  width: 100%;
  text-align: left;
  header {
    color: $blue-1000;
    margin: 0;
    padding: 0 20px;
    background: url("../../assets/newImges/sellers-page/backgrround-elipse-side.png")
      100% center;
    background-size: cover;
    min-height: 80vh;

    h1 {
      text-align: center;
      font-size: 64px;
    }
    p {
      font-size: 24px;
    }
  }
  main {
    padding: 20px;
    margin: 0;

    h2 {
      font-size: 40px;
    }
    p {
      font-size: 24px;
    }
    .items {
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 5px;
        padding: 10px;
        border-radius: 12px;
        background-color: $gray-blue-500;
        margin: 10px 0;
        img {
          width: 60px;
          height: 60px;
        }
        p {
          font-size: 14px;
          margin: 0;
        }
      }
    }
  }
  section {
    padding: 30px 10px;
    div {
      background-color: $gray-blue-500;
      border-radius: 12px;
      padding: 10px;
    }
    .underlined {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  @media screen and (min-width: 768px) {
    padding: 0;
    header {
      background-repeat: no-repeat;
      padding: 20px 16%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      // min-height: 95vh;
      h1 {
        // font-size: 100px;
        text-align: left;
      }
      .btn {
        max-width: 300px;
      }
    }
    main {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      padding: 80px 16%;
      display: flex;
      gap: 20px;
      align-items: center;
      h2 {
        font-size: 64px;
      }
      h3 {
        font-size: 36px;
      }
      .items {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        // overflow: scroll;
        flex: 0 0 40%;
        padding-left: 20%;
        // width: fit-content;
        .item {
          width: 90%;
          padding: 20px;
          user-select: none;
          text-align: right;
          p {
            font-size: 16px;
          }
          &.bigger {
            width: 100%;
          }
        }
      }
    }
    section {
      min-height: 700px;
      padding: 80px 16%;

      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10%;
        text-align: center;
        .btn {
          max-width: 300px;
        }
      }
    }
  }
}
</style>
